import { useEnsureScript } from '../../shared';

declare global {
	interface Window {
		eziDebit: any;
	}
}

export const EZI_CUSTOMER_REF_ELEMENT = 'eziDebitCustomerRefElement';

export type EziDebitEnvironmentSettings = { sandbox?: boolean; publicKey: string };

export function useEziDebitClientScripts(eziSettings: EziDebitEnvironmentSettings) {
	const endpoint = eziSettings?.sandbox
		? 'https://api.demo.ezidebit.com.au/V3-5/public-rest'
		: 'https://api.ezidebit.com.au/V3-5/public-rest';
	return useEnsureScript(`https://static.ezidebit.com.au/javascriptapi/js/ezidebit_2_0_0.js`, () =>
		window.eziDebit.init(eziSettings.publicKey, null, endpoint)
	);
}
